import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { Observable } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

const PERCENT = 100;

@Component({
  selector: 'app-featured-discount-badge',
  templateUrl: './featured-discount-badge.template.html',
  styleUrls: ['./featured-discount-badge.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, NgIf, AsyncPipe],
})
export class FeaturedDiscountBadgeComponent implements OnChanges {
  @Input() public price?: number | null;
  @Input() public originalPrice?: number | string | null;
  @Input() public upToDiscount?: number | null;
  @Input() public flagMode?: boolean | null = false;
  @Input() public goodDealMode?: boolean | null = false;
  @Input() public redColor?: boolean | null = false;

  public readonly isRtl$: Observable<boolean>;

  public discount: number;

  constructor(private readonly akitaRouterQuery: AkitaRouterQuery) {
    this.discount = 0;
    this.isRtl$ = this.akitaRouterQuery.selectIsRtlLayout();
  }
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.price || changes?.originalPrice || changes?.upToDiscount) {
      if (this.upToDiscount) {
        this.discount = this.upToDiscount || 0;
      } else {
        const price = this.price || 0;
        const originalPriceStr = this.originalPrice || 0;

        if (price && originalPriceStr) {
          const original = Number(originalPriceStr);
          this.discount = Math.floor(((price - original) * PERCENT) / original);
        }
      }
    }
  }
}
